import React from 'react';

import Link from '@buyside/components/presentation/Link/link';

import { entityUrl } from '@buyside/util/urlHelper';

import InfoTable from '@buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import { Maybe } from '@interfaces/graphql-typings';
import { MentionedEntity } from '@buyside/components/presentation/EntityMention/entityMentionAutocomplete';

import styles from '@buyside/components/presentation/WhitePaper/styles.scss';

const MentionedEntities: React.FC<{ mentionedEntities: Maybe<MentionedEntity>[] }> = ({
  mentionedEntities
}) => (
  <InfoTable dataTag="related-companies" title="Related Companies" isLocked={false}>
    {(): React.ReactElement => (
      <div className={styles.tickerList}>
        {mentionedEntities.map(
          entity =>
            entity?.primarySymbol && (
              <Link key={entity.id} to={entityUrl(entity.id)}>
                {entity.primarySymbol}
              </Link>
            )
        )}
      </div>
    )}
  </InfoTable>
);

export default MentionedEntities;
